export default __webpack_public_path__ + "static/media/close.c91ccb31.svg";